import { Badge, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';
import { trackGovernanceComingSoonClicked } from 'src/Services/Mixpanel/events';
import { AssetGovernanceFields } from 'src/types/governance.types';
import { getStructureVocabulary } from 'src/Utils/legalStructureVocabulary';

import styles from './GovernanceComingSoonSection.module.scss';

type ModuleKey = 'budget' | 'convention' | 'planning';

const GovernanceComingSoonSection = () => {
  const { t } = useTranslation();
  const { data: asset } = useFetchAssetDetails();
  const governance = asset as unknown as AssetGovernanceFields | undefined;
  const vocabulary = getStructureVocabulary(t, governance?.legalStructure);

  const cards: { key: ModuleKey; emoji: string; label: string }[] = [
    {
      key: 'budget',
      emoji: '💶',
      label: t('admin.governance.comingSoon.budget', 'Gouvernance budgétaire'),
    },
    {
      key: 'convention',
      emoji: '📜',
      label: vocabulary.conventionLabel,
    },
    {
      key: 'planning',
      emoji: '🗓️',
      label: t('admin.governance.comingSoon.planning', 'Gouvernance du planning'),
    },
  ];

  const handleClick = (module: ModuleKey) => {
    trackGovernanceComingSoonClicked({ module });
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('admin.governance.comingSoon.title', 'Prochainement')}</div>
      <div className={styles.grid}>
        {cards.map(card => (
          <div
            key={card.key}
            className={styles.card}
            onClick={() => handleClick(card.key)}
            role="button"
            tabIndex={0}
          >
            <div className={styles.cardHeader}>
              <span className={styles.emoji}>{card.emoji}</span>
              <span className={styles.cardTitle}>{card.label}</span>
            </div>
            <Group>
              <Badge size="xs" variant="light" color="gray">
                {t('admin.governance.comingSoon.badge', 'Bientôt disponible')}
              </Badge>
            </Group>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GovernanceComingSoonSection;
